import { render } from "./Header.vue?vue&type=template&id=0edc0cc8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=0edc0cc8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0edc0cc8"

export default script